import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignStockVinsService {
  private apiUrl = environment.apiURL + 'campaign-stock-vins';

  constructor(private http: HttpClient) { }

  getVins(
    pageNumber: number = 1,
    pageSize: number = 25,
    params: any = {},
    sortColumn: string = 'id',
    sortDirection: string = 'desc'
  ): Observable<any> {
    return this.http.get(this.apiUrl, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

  getVin(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference);
  }

  createVin(body: any): Observable<any> {
    return this.http.post(this.apiUrl + '/new', body);
  }

  updateVin(reference: string, body: any): Observable<any> {
    return this.http.put(this.apiUrl + '/' + reference + '/update', body);
  }

  deleteVin(reference: string): Observable<any> {
    return this.http.delete(this.apiUrl + '/' + reference + '/delete');
  }

  importVins(formData: FormData): Observable<any> {
    return this.http.post(this.apiUrl + '/import', formData);
  }

  exportVins(params: any = {}): Observable<any> {
    return this.http.get(this.apiUrl + '/export', {
      params: { ...params },
    });
  }
}
